import{checkIfStringStartsWith}from"../../../helper/checkIfStringStartsWith";/**
 *
 * This function checks whether a page is considered utility page which giveaway0123
 * banner and modal is not required
 * @param path
 * @returns boolean
 */export function isGiveaway0123UtilityPage(path){var utilityPages=["/404","/library","/maintenance"];if(checkIfStringStartsWith(path,utilityPages)){return true;}return false;}